module.exports = __webpack_public_path__ + "img/icon-amex.6d8ac9d7.svg";